import { getLogger } from '@nerdwallet/logging';

export default getLogger('front-page-next');
